import '../../OrganizationModals.scss';

import { Input } from '@trackman/web-shared-components';
import { Modal } from '@trackman/web-shared-components';
import { ReactComponent as PencilIcon } from 'images/icons/Pencil.svg';
import { useTranslation } from 'react-i18next';
import { useRenameClass } from 'queryHooks/Organization/Classes/useRenameClass';
import { Class } from 'types/organization/classes';
import { useState } from 'react';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

type Props = {
  isOpen: boolean;
  editedClass: Class;
  close: () => void;
};

export const RenameClassModal = ({ isOpen, editedClass, close }: Props) => {
  const { t } = useTranslation();
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  const [newClassName, setNewClassName] = useState<string>(editedClass?.name ?? '');
  const renameClass = useRenameClass(selectedOrganizationId, { onSuccess: () => close() });

  const confirm = () => renameClass.mutate({ ...editedClass, name: newClassName });

  return (
    <Modal
      open={isOpen}
      onClose={close}
      aria-labelledby={t('RenameClass', { ns: 'classPage' })}
      aria-describedby={t('RenameSelectedClass', { ns: 'classPage' })}
      className='organization-modal'
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => close(),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Save', { ns: 'classPage' }),
        onClick: () => confirm(),
      }}
      title={t('EditClassName', { ns: 'classPage' })}
      titleIcon={<PencilIcon />}
    >
      <div className='modal-body'>
        <p className='name-your-class'>
          <strong>{t('NameYourClass', { ns: 'organizationPage' })}</strong>
        </p>
        <Input
          label={t('NameYourClass', { ns: 'organizationPage' })}
          value={newClassName ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewClassName(e.currentTarget.value)}
        />
      </div>
    </Modal>
  );
};

export default RenameClassModal;
